import { PropsWithChildren } from 'react'
import styles from './Table.module.scss'
import clsx from 'clsx'

interface Props extends PropsWithChildren {
    alignCenter?: boolean
    className?: string
}

export const TableCell = ({ children, alignCenter = false, className }: Props) => {
    return <td className={clsx(styles.cell, className, { [styles.alignCenterCell]: alignCenter })}>{children}</td>
}
